var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.663,
    height: 30.483,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1682"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1668",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.152 4.586h-7.307V3.118A3.12 3.12 0 0 0 14.728 0H3.118A3.12 3.12 0 0 0 0 3.118v21.857a5.514 5.514 0 0 0 5.508 5.508h19.644c2.85 0 5.202-2.174 5.505-5.263-.004.13.006-.057.006-.245V10.097a5.518 5.518 0 0 0-5.51-5.51m2.86 20.388a2.864 2.864 0 0 1-2.86 2.86H5.507a2.865 2.865 0 0 1-2.86-2.86V3.118c0-.258.212-.467.47-.467h11.61c.257 0 .468.21.468.467v2.794c0 .73.592 1.325 1.325 1.325h8.631a2.862 2.862 0 0 1 2.86 2.86v14.878Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6678"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30.663v30.483H0V0z",
    "data-name": "Rectangle 1472"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.5566074d94de86de641cb957c3a41c5e.svg";
export { ForwardRef as ReactComponent };